<span mat-dialog-title>{{'dialog.cant-open.title.' + data.reason | translate}}</span>
<mat-dialog-content class="mat-typography">
  <div><h4>{{'dialog.cant-open.summary.' + data.reason | translate}}</h4></div>
  <div>
    <h3>{{'dialog.cant-open.id' | translate}}</h3>
    <div>{{data.nodeId}}</div>
  </div>
  @if (data.noLoadedNodes) {
    <div>
      <h3>{{'dialog.cant-open.go-to-startnode' | translate}}</h3>
      <div>{{'dialog.cant-open.go-to-startnode.details' | translate}}</div>
    </div>
  }
  @if (data.isStartNode) {
    <div>
      <h3>{{'dialog.cant-open.was-startnode' | translate}}</h3>
      <div>{{'dialog.cant-open.was-startnode.details' | translate}}</div>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions >
  @if (!data.isStartNode) {
    <button mat-raised-button mat-dialog-close>{{'button.close' | translate}}</button>
  }
  @if (data.isStartNode) {
    <button mat-raised-button mat-dialog-close (click)="logout()">{{'button.logout' | translate}}</button>
  }
</mat-dialog-actions>
